

import { Logger } from 'src/app/api/helper/app-error-logger';
import { Auftrag, Personal, Fahrzeug, Auftragsposition, ReportElement, Wiegedaten, Druckformular } from 'src/app/api/model/swagger-model';
import { Utils } from 'src/app/api/helper/utils';
import { FormatHelper } from 'src/app/api/helper/format-helper';
import { AuftragEx } from 'src/app/api/model/model';

import moment from 'moment';

const log = new Logger('DruckerHelper');

export class DruckerHelper {
    static erstellePlatzhalter(auftrag: AuftragEx, fahrer: Personal, fahrzeug: Fahrzeug, position: Auftragsposition) {
        const now = moment();

        const platzhalter: any = {
            'AktuellesDatum': now.format('DD.MM.YYYY'),
            'AktuelleUhrzeit': now.format('HH:mm'),
            'Key': auftrag.Key,
            'Statuszeit': auftrag.Statuszeit,
            'Auftragsstatus': auftrag.Auftragsstatus,
            'Statusmeldung': auftrag.Statusmeldung,
            'StatusmeldungKey': auftrag.StatusmeldungKey,
            'Auftragsnummer': auftrag.Auftragsnummer,
            'AusdruckNummer': auftrag.AusdruckNummer,
            'Reihenfolge': auftrag.Reihenfolge,
            'Geraet': auftrag.Geraet,
            'Personalnummer': auftrag.Personalnummer,
            'Barcode': auftrag.Barcode,
            'Auftragstyp': auftrag.Auftragstyp,
            'Mandant': auftrag.Mandant,
            'AAbholdatum': auftrag.AAbholdatum,
            'AAbholzeitVon': auftrag.AAbholzeitVon,
            'AAbholzeitBis': auftrag.AAbholzeitBis,
            'AErfasser': auftrag.AErfasser,
            'Abholadresse': auftrag.Abholadresse,
            'AAbladedatum': auftrag.AAbladedatum,
            'AAbladezeitVon': auftrag.AAbladezeitVon,
            'AAbladezeitBis': auftrag.AAbladezeitBis,
            'AHaupflaufContNr': auftrag.AHaupflaufContNr,
            'Quittungsname': auftrag.Quittungsname,
            'WorkflowName': auftrag.WorkflowName,
            'Anmerkungen': auftrag.Anmerkungen,
            'FahrzeugKennung': auftrag.FahrzeugKennung,
            'FahrzeugKennung2': auftrag.FahrzeugKennung2,
            'FahrzeugKennung3': auftrag.FahrzeugKennung3,
            'Info1': auftrag.Info1,
            'Info2': auftrag.Info2,
            'Info3': auftrag.Info3,
            'DetailInfo1': auftrag.DetailInfo1,
            'DetailInfo2': auftrag.DetailInfo2,
            'DetailInfo3': auftrag.DetailInfo3,
            'Kundennummer': auftrag.Erzeugeradresse?.AdressNummer,
            'BezahlungBetrag': auftrag.BezahlungBetrag,
            'BezahlungArt': auftrag.BezahlungArt,
            'IstBezahlt': auftrag.IstBezahlt,
            'SummeBrutto': FormatHelper.formatPreis(auftrag.SummeBrutto),
            'SummeNetto': FormatHelper.formatPreis(auftrag.SummeNetto),
            'SummeMwst': FormatHelper.formatPreis(auftrag.SummeMwst),
            'Abholadresse.AdressNummer': auftrag.Abholadresse?.AdressNummer,
            'Abholadresse.Name1': auftrag.Abholadresse?.Name1,
            'Abholadresse.Name2': auftrag.Abholadresse?.Name2,
            'Abholadresse.Name3': auftrag.Abholadresse?.Name3,
            'Abholadresse.NameVollstaendig': [auftrag.Abholadresse?.Name1, auftrag.Abholadresse?.Name2, auftrag.Abholadresse?.Name3].filter(p => p).join('\n'),
            'Abholadresse.Strasse': auftrag.Abholadresse?.Strasse,
            'Abholadresse.PLZ': auftrag.Abholadresse?.PLZ,
            'Abholadresse.Ort': auftrag.Abholadresse?.Ort,
            'Abholadresse.LKZ': auftrag.Abholadresse?.LKZ,
            'Abholadresse.Telefon': auftrag.Abholadresse?.Telefon,
            'Abholadresse.LieferscheinEmail': auftrag.Abholadresse?.LieferscheinEmail,
            'Abholadresse.Ansprechpartner': auftrag.Abholadresse?.Ansprechpartner,
            'Abholadresse.GeoX': auftrag.Abholadresse?.GeoX,
            'Abholadresse.GeoY': auftrag.Abholadresse?.GeoY,
            'Abholadresse.PortalPwd': auftrag.Abholadresse?.PortalPwd,
            'Erzeugeradresse.AdressNummer': auftrag.Erzeugeradresse?.AdressNummer,
            'Erzeugeradresse.Name1': auftrag.Erzeugeradresse?.Name1,
            'Erzeugeradresse.Name2': auftrag.Erzeugeradresse?.Name2,
            'Erzeugeradresse.Name3': auftrag.Erzeugeradresse?.Name3,
            'Erzeugeradresse.NameVollstaendig': [auftrag.Erzeugeradresse?.Name1, auftrag.Erzeugeradresse?.Name2, auftrag.Erzeugeradresse?.Name3].filter(p => p).join('\n'),
            'Erzeugeradresse.Strasse': auftrag.Erzeugeradresse?.Strasse,
            'Erzeugeradresse.PLZ': auftrag.Erzeugeradresse?.PLZ,
            'Erzeugeradresse.Ort': auftrag.Erzeugeradresse?.Ort,
            'Erzeugeradresse.LKZ': auftrag.Erzeugeradresse?.LKZ,
            'Erzeugeradresse.Telefon': auftrag.Erzeugeradresse?.Telefon,
            'Erzeugeradresse.Ansprechpartner': auftrag.Erzeugeradresse?.Ansprechpartner,
            'Erzeugeradresse.GeoX': auftrag.Erzeugeradresse?.GeoX,
            'Erzeugeradresse.GeoY': auftrag.Erzeugeradresse?.GeoY,
            'Erzeugeradresse.PortalPwd': auftrag.Erzeugeradresse?.PortalPwd,
            'Verwerteradresse.AdressNummer': auftrag.Verwerteradresse?.AdressNummer,
            'Verwerteradresse.Name1': auftrag.Verwerteradresse?.Name1,
            'Verwerteradresse.Name2': auftrag.Verwerteradresse?.Name2,
            'Verwerteradresse.Name3': auftrag.Verwerteradresse?.Name3,
            'Verwerteradresse.NameVollstaendig': [auftrag.Verwerteradresse?.Name1, auftrag.Verwerteradresse?.Name2, auftrag.Verwerteradresse?.Name3].filter(p => p).join('\n'),
            'Verwerteradresse.Strasse': auftrag.Verwerteradresse?.Strasse,
            'Verwerteradresse.PLZ': auftrag.Verwerteradresse?.PLZ,
            'Verwerteradresse.Ort': auftrag.Verwerteradresse?.Ort,
            'Verwerteradresse.LKZ': auftrag.Verwerteradresse?.LKZ,
            'Verwerteradresse.Telefon': auftrag.Verwerteradresse?.Telefon,
            'Verwerteradresse.Ansprechpartner': auftrag.Verwerteradresse?.Ansprechpartner,
            'Verwerteradresse.GeoX': auftrag.Verwerteradresse?.GeoX,
            'Verwerteradresse.GeoY': auftrag.Verwerteradresse?.GeoY,
            'Fahrzeugkennzeichen': fahrzeug?.kennzeichen,
            'Fahrer.Vorname': fahrer?.vorname,
            'Fahrer.Nachname': fahrer?.nachname,
            'Fahrer.Personalnummer': fahrer?.personalnummer,
            'Stammtour': auftrag.TourKey?.split('U')[0],
        };

        if (auftrag.Unterschriften) {
            platzhalter['UnterschriftERZ.Name'] = '';
            platzhalter['UnterschriftERZ.Datum'] = '';
            platzhalter['UnterschriftBEF.Name'] = '';
            platzhalter['UnterschriftBEF.Datum'] = '';
            platzhalter['UnterschriftENT.Name'] = '';
            platzhalter['UnterschriftENT.Datum'] = '';

            for (const u of auftrag.Unterschriften) {
                platzhalter['Unterschrift' + u.Typ + '.Name'] = u.Name;
                platzhalter['Unterschrift' + u.Typ + '.Datum'] = u.Datum;
            }
        }

        if (auftrag.Zusatzdaten) {
            for (const key in auftrag.Zusatzdaten) {
                if (Object.prototype.hasOwnProperty.call(auftrag.Zusatzdaten, key)) {
                    platzhalter['Zusatzdaten.' + key] = auftrag.Zusatzdaten[key];
                }
            }
        }

        platzhalter['MwstSatz1'] = '';
        platzhalter['MwstSatz2'] = '';
        platzhalter['MwstSatz3'] = '';
        platzhalter['MwstNettoBetrag1'] = '';
        platzhalter['MwstNettoBetrag2'] = '';
        platzhalter['MwstNettoBetrag3'] = '';
        platzhalter['MwstBetrag1'] = '';
        platzhalter['MwstBetrag2'] = '';
        platzhalter['MwstBetrag3'] = '';
        platzhalter['MwstVorhanden1'] = false;
        platzhalter['MwstVorhanden2'] = false;
        platzhalter['MwstVorhanden3'] = false;

        if (auftrag.MwstBetraege) {
            for (let i = 0; i < auftrag.MwstBetraege.length; i++) {
                const eintrag = auftrag.MwstBetraege[i];
                const nummer = i + 1;

                platzhalter['MwstVorhanden' + nummer] = true;
                platzhalter['MwstSatz' + nummer] = eintrag.MwstSatz;
                platzhalter['MwstNettoBetrag' + nummer] = FormatHelper.formatPreis(eintrag.NettoBetrag);
                platzhalter['MwstBetrag' + nummer] = FormatHelper.formatPreis(eintrag.MwstBetrag);
            }
        }

        if (position) {
            platzhalter.PosNr = position.PosNr;
            platzhalter.ArtikelKey = position.ArtikelKey;
            platzhalter.Bezeichnung = position.Bezeichnung;
            platzhalter.Bezeichnung2 = position.Bezeichnung2;
            platzhalter.Menge = position.Menge;
            platzhalter.Einheit = position.Einheit;
            platzhalter.EinzelVK = FormatHelper.formatEP(position.EinzelVK);
            platzhalter.NettoBetrag = FormatHelper.formatPreis(position.NettoBetrag);
            platzhalter.MwstSatz = position.MwstSatz;
            platzhalter.MwstBetrag = FormatHelper.formatPreis(position.MwstBetrag);
            platzhalter.GewichtInKg = position.GewichtInKg;
            platzhalter.BhAktion = position.BhAktion;
            platzhalter.Anmerkungen = position.Anmerkungen;
            platzhalter.GTIN = position.GTIN;
            platzhalter.CHARGE = '';
            platzhalter.MHD = '';
            platzhalter.MHDGS = '';
            platzhalter.GTINX = '00000000000000';
            platzhalter.MHDGS = '000000';

            // Komma-separierte Liste mit allen Wiegenummern.
            // Bei "Wiegungen im Ausdruck = alle" wird das je Wiegung überschrieben,
            // siehe getPlatzhalterListeFuerElement().
            platzhalter.WiegeNummern = this.getWiegenummernString(position);

            platzhalter['Wiegung1.W1'] = '';
            platzhalter['Wiegung1.W2'] = '';
            platzhalter['Wiegung1.Brutto'] = '';
            platzhalter['Wiegung1.Tara'] = '';
            platzhalter['Wiegung1.Netto'] = '';

            if (position.Wiegungen?.length >= 1) {
                this.setzeWiegungPlatzhalter(platzhalter, position.Wiegungen[0]);
            }

            if (position.GTIN) {
                platzhalter.GTINX = position.GTIN.toString().padStart(14, '0');
            }

            if (position.Eigenschaften) {
                for (const eigenschaft of position.Eigenschaften) {
                    try {
                        platzhalter[eigenschaft.Bezeichnung] = eigenschaft.Wert;
                        platzhalter[eigenschaft.Key] = eigenschaft.Wert;
                        platzhalter[eigenschaft.Bezeichnung + "MitText"] = eigenschaft.Bezeichnung + ": " + eigenschaft.Wert;

                        if (eigenschaft.Key === 'MHD' && eigenschaft.Wert && eigenschaft.Wert) {
                            const datum = Utils.parseDatum(eigenschaft.Wert);

                            if (datum) {
                                platzhalter['MHDGS'] = datum.format('YYMMDD');
                            }
                        }
                    } catch (err) {
                        // ignore
                    }
                }
            }

            platzhalter.BehaelterNummern = '';
            platzhalter.BehaelterNummernAbgezogen = '';
            
            if (position.Behaelter?.length) {
                // nur abgezogene Behälter aufdrucken (OFK), daher weiterer Platzhalter
                const behaelterNummern = position.Behaelter.map(p => p.BehaelterNr).filter(p => p);
                platzhalter.BehaelterNummern = Utils.joinNotEmpties(', ', ...behaelterNummern);

                const behaelterNummernabgezogen = position.Behaelter.filter(p => p.Aktion === 'abziehen').map(p => p.BehaelterNr).filter(p => p); // OFK: abgezogene Behälter, Aktion: abziehen
                platzhalter.BehaelterNummernAbgezogen = Utils.joinNotEmpties(', ', ...behaelterNummernabgezogen);
            }
        }

        return platzhalter;
    }

    /**
     * Setzt die Platzhalter einer einzelnen Wiegung.
     */
    static setzeWiegungPlatzhalter(platzhalter: any, wiegung: Wiegedaten) {
        const brutto = FormatHelper.formatReadableNumber(wiegung.Wiegung1);
        const tara = FormatHelper.formatReadableNumber(wiegung.Wiegung2);

        platzhalter['Wiegung1.W1'] = brutto;
        platzhalter['Wiegung1.W2'] = tara;

        // Alias-Namen, damit im Formular auch die sprechenden Bezeichnungen verwendet werden können.
        platzhalter['Wiegung1.Brutto'] = brutto;
        platzhalter['Wiegung1.Tara'] = tara;

        platzhalter['Wiegung1.Netto'] = FormatHelper.formatReadableNumber(wiegung.Netto);
    }

    /**
     * Gibt zurück, mit welchen Platzhaltern ein Report-Element gedruckt werden soll.
     *
     * Normalerweise ist das genau ein Satz, das Element wird also einmal gedruckt.
     *
     * Ist am Druckformular "Alle Wiegungen drucken" gesetzt und enthält das Element Wiegungs-Platzhalter,
     * wird je Wiegung ein eigener Satz zurückgegeben. Das Element wird dann einmal pro Wiegung gedruckt,
     * jeweils mit den Werten und der Bon-Nummer dieser einen Wiegung.
     */
    static getPlatzhalterListeFuerElement(druckformular: Druckformular, e: ReportElement, platzhalter: any, position: Auftragsposition): any[] {
        if (!e?.Content || e.Content.indexOf('{Wiegung1.') < 0) {
            // Das Element enthält keine Wiegungs-Platzhalter.
            return [platzhalter];
        }

        if (!druckformular?.AlleWiegungenDrucken) {
            // Standard: nur die erste Wiegung drucken.
            return [platzhalter];
        }

        const wiegungen = position?.Wiegungen;

        if (!wiegungen || wiegungen.length < 2) {
            // Nichts zu wiederholen.
            return [platzhalter];
        }

        return wiegungen.map(w => {
            const p = { ...platzhalter };

            this.setzeWiegungPlatzhalter(p, w);

            // Je Wiegung soll nur die eigene Bon-Nummer stehen, nicht die Liste aller Nummern.
            const nummern: string[] = [];

            if (w.Wiegenummer) {
                nummern.push(Utils.getString(w.Wiegenummer));
            }

            if (w.Wiegenummer2) {
                nummern.push(Utils.getString(w.Wiegenummer2));
            }

            p.WiegeNummern = nummern.join(', ');

            return p;
        });
    }

    /**
     * Erstellt einen Stirng mit den Wiegenummern einer Auftragsposition.
     */
    static getWiegenummernString(position: Auftragsposition): string {
        let wiegeNummern: string[] = [];

        if (position.Wiegungen?.length) {
            for (const w2 of position.Wiegungen) {
                if (w2.Wiegenummer) {
                    wiegeNummern.push(Utils.getString(w2.Wiegenummer));
                }

                if (w2.Wiegenummer2) {
                    wiegeNummern.push(Utils.getString(w2.Wiegenummer2));
                }
            }
        }

        if (position.Wiegungen2?.length) {
            for (const w2 of position.Wiegungen2) {
                if (w2.WiegeNr) {
                    wiegeNummern.push(w2.WiegeNr);
                }
            }
        }

        return wiegeNummern.join(', ');
    }

    static isDruckbedingungOk(e: ReportElement, auftrag: Auftrag, fahrer: Personal, fahrzeug: Fahrzeug, platzhalter: any, position: Auftragsposition = null): boolean {
        if (e.DruckBedingung) {
            try {
                // tslint:disable:only-arrow-functions
                // tslint:disable:no-shadowed-variable
                // tslint:disable:no-eval
                const Auftrag = auftrag;
                const Fahrer = fahrer;
                const Fahrzeug = fahrzeug;
                const Position = position;
                const X = platzhalter;

                return eval(e.DruckBedingung);
            } catch (err) {
                log.error(`Fehlerhafte Druckbedingung '${e.DruckBedingung}': ${Utils.getErrorMessage(err)}`, err);
                return false;
            }
        }

        return true;
    }
}